import { Selector } from '@ngxs/store';

import { BcStateContext, BcStateListContext } from '@bayclubs/state';
import { CheckPersonRulesMatrixModel, GetPersonModel, PersonModel } from '@bayclubs/court-booking-employee-api';

import { PlayersStateModel } from './players.state.model';
import { PlayersState } from './players.state';

export class PlayersSelectors {
    @Selector([PlayersState])
    static getPlayer(state: PlayersStateModel): BcStateContext<GetPersonModel> {
        return state.player;
    }

    @Selector([PlayersState])
    static getPlayers(state: PlayersStateModel): BcStateListContext<PersonModel> {
        return state.players;
    }

    @Selector([PlayersState])
    static getSelectedPlayer(state: PlayersStateModel): PersonModel {
        return state.selectedPlayer;
    }

    @Selector([PlayersState])
    static getSelectedPlayerRulesMatrix(state: PlayersStateModel): CheckPersonRulesMatrixModel {
        return state.selectedPlayerRulesMatrix;
    }
}
